import { GET_TOKEN } from "@/services/local.storage.service";

export function getMenuAccessFromToken() {
  const token = GET_TOKEN();
  if (!token) return [];

  try {
    const parts = token.split(".");
    if (parts.length !== 3) return [];

    const base64UrlPayload = parts[1];
    const base64 = base64UrlPayload.replace(/-/g, "+").replace(/_/g, "/");
    const decodedPayload = JSON.parse(atob(base64));

    if (decodedPayload.menu_access) {
      if (typeof decodedPayload.menu_access === "string") {
        return JSON.parse(decodedPayload.menu_access);
      }
      return decodedPayload.menu_access;
    }

    return [];
  } catch (error) {
    console.error("Error getting menu access from token:", error);
    return [];
  }
}

export function hasMenuAccess(resource, action) {
  const menuAccess = getMenuAccessFromToken();

  return menuAccess.some(access => {
    if (access.accessRoleCode !== resource) return false;

    const actions = access.ActionList.split(",").map(a => a.trim().toLowerCase());
    return actions.includes(action.toLowerCase());
  });
}

// Helper function to decode JWT
export function decodeJwt(token) {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      throw new Error("Invalid JWT format");
    }

    const base64UrlPayload = parts[1];
    const base64 = base64UrlPayload.replace(/-/g, "+").replace(/_/g, "/");
    const decodedPayload = JSON.parse(atob(base64));

    // Parse menu_access if it's a JSON string
    if (decodedPayload.menu_access && typeof decodedPayload.menu_access === "string") {
      try {
        decodedPayload.menu_access = JSON.parse(decodedPayload.menu_access);
      } catch (e) {
        console.error("Error parsing menu_access:", e);
      }
    }

    return decodedPayload;
  } catch (error) {
    console.error("Error decoding JWT:", error);
    return null;
  }
}
